import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CompareArrowsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"compare_arrows"}/>
}
